import styles from './NextButton.module.scss'
import NextIcon from '../../../../../../public/assets/next-icon.svg'
interface INextButtonProps {
  disabled: boolean
  clickCallback: Function
}

export default function NextButton({ disabled, clickCallback }: INextButtonProps) {
  return (
    <button className={styles['next-button']} disabled={disabled} onClick={() => clickCallback()}>
      <NextIcon />
    </button>
  )
}
